import React from 'react'
import List from 'components/CustomTenders/List'

const CustomTenders = () => {
  return (
    <div className="items sales-events">
      <div className="header">
        <ul className="header__menu">
          <li className="header__menu-item">Internal Name</li>
          {/* This will be uncomment in future use */}
          {/* <li className="header__menu-item">Taxable</li> */}
          {/* <li className="header__menu-item">No-Op Tender</li> */}
          <li className="header__menu-item">Status</li>
        </ul>
      </div>
      <List />
    </div>
  )
}

export default CustomTenders
